import { useEffect , useState} from 'react';

export const LeaderBoard = ({IMAGE_PATH,IMAGE_PATH_Leader, contributors, BASE_URL_OPENFORGE}) => {

    const [updatedContributor, setUpdatedContributor] = useState([]);

    // Capitalize first letter, lowercase the rest
    const capitalizeWords = (str) => {
        return str.split(' ')  
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
          .join(' '); 
    };

    // sorting certificate by decreasing order and assigning new rank and Capitalizing the word
    useEffect(() => {

        if (contributors && contributors.length > 0) {
            const sortedByCertificates = [...contributors]
            .sort((a, b) => (b.no_of_certificates || 0) - (a.no_of_certificates || 0))
            .map((contributor, index) => ({
              ...contributor,
              new_rank: index + 1,
            }));

          const updatedList = sortedByCertificates.map((contributor) => {
            if (contributor.name_of_participant) {
              const updatedName = capitalizeWords(contributor.name_of_participant);
              return { ...contributor, name_of_participant: updatedName };  
            }
            return contributor;
          });
    
          setUpdatedContributor(updatedList);  
        }
    }, []);  

 //onClick userProfile
    // const userProfie = (userId) => {
    // console.log("userId",`${BASE_URL_OPENFORGE}/users/${userId}`)
    // setTimeout(() => {
    //     if (userId) {
    //         window.location.href = `${BASE_URL_OPENFORGE}/users/${userId}`;
    //       }     
    // }, 3000);
    // }
      
    // Separate arrays for even and odd ranks
    // const evenRankParticipants = contributors.filter(contributor => contributor.rank % 2 === 0);
    const evenRankParticipants = (updatedContributor ?? []).filter(contributor => contributor.new_rank % 2 === 0);

    // const oddRankParticipants = contributors.filter(contributor => contributor.rank % 2 !== 0);
    const oddRankParticipants = (updatedContributor ?? []).filter(contributor => contributor.new_rank % 2 !== 0);


    return (
        <>
            <section id="load_board" aria-labelledby="leaderboard-heading">
                    <div className="container leaderboard pt-4 pb-5">
                        <h1 id="leaderboard-heading" className="mb-3 mt-4 text-center">Leader <span>Board</span></h1>
                        <p className="leaderboard-subtitle mb-5">Appreciating the highest contributors for their hard work and quality submissions.</p>
                        <div className='row'>
                            {
                            (oddRankParticipants.length > 0)
                            ?
                                <div className='col-sm-6'>
                                    {
                                       oddRankParticipants.map((item, index) => (
                                        (item?.name_of_participant)
                                        ?
                                        <a 
                                        href={`${BASE_URL_OPENFORGE}/users/${item.openforge_id}?return_profile=1`} 
                                         className="card custom-card mb-4 text-decoration-none text-dark" 
                                          key={index}  
                                        >                                                                                      
                                            <div className="d-flex align-items-center">
                                                <img src={item?.profile_image && item.profile_image.trim() ? `${IMAGE_PATH_Leader}/profile_images/${item.profile_image.split('/').pop()}`:''} alt={item.name_of_participant} className="profile-img"/>
                                                <div className="d-flex flex-column ms-3">
                                                    <div className="d-flex align-items-center">
                                                        <h2 className="card-title mb-0">{item.name_of_participant}</h2>
                                                    
                                                    </div>
                                                    <div className="d-flex  flex-column flex-lg-row   align-items-start mt-3">                 
                                                        <div className="d-flex flex-row flex-sm-row align-items-center">
                                                            <p className="mb-0 me-2 task-text" 
                                                                style={{   
                                                                    width: "40px",
                                                                    borderRadius: "20%",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    backgroundColor: "#1987540f",
                                                                    color:"#00675B",
                                                                    fontWeight:600
                                                                }}>{item.No_of_tasks_completed || 0}</p> 
                                                        
                                                        <p  className="mb-0 me-0 me-md-4  task-text" >Tasks Completed</p>
                                                        </div>
                                                        <div className="d-flex flex-row flex-sm-row align-items-center mt-2 mt-lg-0">
                                                            <p className="mb-0 me-2 task-text" 
                                                                style={{    
                                                                    width: "40px",
                                                                    borderRadius: "20%",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    color:"#00675B",
                                                                    fontWeight:600,
                                                                    backgroundColor: "#1987540f"
                                                                }}>{item.no_of_certificates || 0}</p> 

                                                            <p className="mb-0 me-0 me-md-2 task-text" >Certificates Earned</p>
                                                        </div>

                                                    </div>
                                                </div>
                                            <div className="rating-icons ms-auto mb-4 " >
                                                    {/* <span className="card-number">{item.rank}</span> */}
                                                    {/* previous code */}
                                                    {/* <span className="rating_img ml-2">
                                                    {Array.from({ length: item.user_avg_rating || 0 }, (_, index) => (
                                                        <img 
                                                            key={index} 
                                                            src={`${IMAGE_PATH}/mdi_badge-outline.png`} 
                                                            alt="mdi_badge-outline.png" 
                                                        />
                                                    ))} */}
                                                        {/* <img src={`${IMAGE_PATH}/mdi_badge-outline.png`} alt="mdi_badge-outline.png"/>
                                                        <img src={`${IMAGE_PATH}/mdi_badge-outline.png`}alt="mdi_badge-outline.png"/>
                                                        <img src={`${IMAGE_PATH}/mdi_badge-outline.png`} alt="mdi_badge-outline.png"/>
                                                        <img src={`${IMAGE_PATH}/mdi_badge-outline.png`} alt="mdi_badge-outline.png"/> */}
                                                    {/* </span> */}
                                                <span style={{fontWeight:"bold", marginRight:'4px'}} className='task-text'>
                                                    {item.user_avg_rating}   
                                                </span>                                           
                                                <img 
                                                    key={index} 
                                                    src={`${IMAGE_PATH}/mdi_badge-outline.png`} 
                                                    alt="mdi_badge-outline.png" 
                                                />
                                                </div>
                                            </div>
                                        </a>
                                        :
                                        ""        
                                       )) 
                                    }
                                </div>
                            :
                            ''
                            }
                            {
                                (evenRankParticipants.length > 0)
                                ?
                                <div className='col-sm-6'>
                                    {
                                        evenRankParticipants.map((item, index) => (
                                            (item?.name_of_participant)
                                            ?
                                            <a 
                                             href={`${BASE_URL_OPENFORGE}/users/${item.openforge_id}?return_profile=1`} 
                                             className="card custom-card mb-4 text-decoration-none text-dark" 
                                             key={index} 
                                            >
                                                <div className="d-flex align-items-center">
                                                    <img src={item?.profile_image && item.profile_image.trim() ? `${IMAGE_PATH_Leader}/profile_images/${item.profile_image.split('/').pop()}`:''} alt={item.name_of_participant} className="profile-img"/>
                                                    <div className="d-flex flex-column ms-3">
                                                        <div className="d-flex align-items-center">
                                                            <h2 className="card-title mb-0">{item.name_of_participant}</h2>
                                                            
                                                        </div>
                                                            <div className="d-flex  flex-column flex-lg-row  align-items-start mt-3">                 
                                                                <div className="d-flex flex-row flex-sm-row align-items-center">
                                                                    <p className="mb-0 me-2 task-text" 
                                                                        style={{   
                                                                            width: "40px",
                                                                            borderRadius: "20%",
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            backgroundColor: "#1987540f",
                                                                            color:"#00675B",
                                                                            fontWeight:600
                                                                        }}>{item.No_of_tasks_completed || 0}</p> 
                                                                
                                                                    <p  className="mb-0 me-0 me-md-4 task-text">Tasks Completed</p>
                                                                </div>
                                                                <div className="d-flex flex-row flex-sm-row align-items-center mt-2 mt-lg-0">
                                                                    <p className="mb-0 me-2 task-text" 
                                                                        style={{    
                                                                            width: "40px",
                                                                            borderRadius: "20%",
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            color:"#00675B",
                                                                            fontWeight:600,
                                                                            backgroundColor: "#1987540f"
                                                                        }}>{item.no_of_certificates || 0}</p> 

                                                                    <p className="mb-0 me-0 me-md-2 task-text" >Certificates Earned</p>
                                                                </div>

                                                        </div>
                                                    </div>
                                                    <div className="rating-icons ms-auto mb-4 " >
                                                        {/* previous code */}
                                                        {/* <span className="card-number">{item.rank}</span> */}
                                                        {/* <span className="rating_img ml-2">
                                                            {Array.from({ length: item.user_avg_rating || 0 }, (_, index) => (
                                                                <img 
                                                                    key={index} 
                                                                    src={`${IMAGE_PATH}/mdi_badge-outline.png`} 
                                                                    alt="mdi_badge-outline.png" 
                                                                />
                                                            ))}
                                                        </span> */}
                                                        <span style={{fontWeight:"bold", marginRight:'4px'}} className="task-text">
                                                            {item.user_avg_rating}   
                                                        </span>                                           
                                                        <img 
                                                            key={index} 
                                                            src={`${IMAGE_PATH}/mdi_badge-outline.png`} 
                                                            alt="mdi_badge-outline.png" 
                                                        />

                                                        {/* <span className="rating_img ml-2">
                                                            <img src={`${IMAGE_PATH}/mdi_badge-outline.png`} alt="mdi_badge-outline.png"/>
                                                            <img src={`${IMAGE_PATH}/mdi_badge-outline.png`} alt="mdi_badge-outline.png"/>
                                                            <img src={`${IMAGE_PATH}/mdi_badge-outline.png`} alt="mdi_badge-outline.png"/>
                                                            <img src={`${IMAGE_PATH}/mdi_badge-outline.png`} alt="mdi_badge-outline.png"/>
                                                        </span> */}
                                                    </div>
                                                </div>
                                            </a>
                                            :
                                            ""
                                        )) 
                                    }
                                </div>
                                :
                                ''
                            }
                        </div>
                    </div>    
              </section>
            <style jsx>{`
            /* Base font-size */
            .task-text {
                font-size: 8px; /* Default for smaller devices */
            }

            /* Larger screens (Tablet and up) */
            @media (min-width: 768px) {
            .task-text {
            font-size: 12px;
            }
            }

            /* Even larger screens (Laptop and up) */
            @media (min-width: 992px) {
            .task-text{
            font-size: 16px;
            }
            }`}</style>
        </>
    );
}